import {
  Box,
  Chip,
  Grid,
  IconButton,
  Popover,
  Typography,
} from '@mui/material';
import parse from 'html-react-parser';
import { FC, useState } from 'react';

import { QualificationQuestionResponse } from '@features/applicationQuestions';
import { borderGrey } from '@styles/colors';
import { bold, medium } from '@styles/fontWeights';
import { CheckIcon, CrossIcon } from '@components/GenralIcons/GenralIcons';

type ApplicationQuestionsTabProps = {
  response: QualificationQuestionResponse;
};

const ApplicationQuestionResponse: FC<ApplicationQuestionsTabProps> = ({
  response: {
    response,
    question,
    disqualify,
    question_type,
    additional_info,
    preferred_answer,
  },
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: borderGrey,
        py: 2,
        pl: 2,
        pr: 4,
        borderRadius: 8,
        '& p': {
          m: 0,
        },
      }}
    >
      <Grid container spacing={3} alignItems="center">
        {disqualify && (
          <Grid
            item
            xs={12}
            sm={1}
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <IconButton
              aria-owns={anchorEl ? 'mouse-over-popover' : undefined}
              aria-haspopup="true"
              onMouseEnter={(event) => setAnchorEl(event.currentTarget)}
              onMouseLeave={handlePopoverClose}
              disableRipple
              data-testid="iconButton"
            >
              {preferred_answer === response ? <CheckIcon /> : <CrossIcon />}
            </IconButton>
          </Grid>
        )}
        <Grid item xs={12} sm={9}>
          <Box display="flex">
            <Typography
              fontWeight={bold}
              mx={1}
              component="span"
              color="text.secondary"
            >
              Q:
            </Typography>
            <Box color="text.secondary" fontWeight={medium}>
              {parse(question)}
            </Box>
          </Box>

          {additional_info && (
            <Box display="flex">
              <Typography
                fontWeight={bold}
                mx={1}
                component="span"
                color="lightPurple"
              >
                A:
              </Typography>
              <Typography
                color="lightPurple"
                fontWeight={medium}
                component="span"
                display="flex"
                fontStyle="italic"
              >
                {`${additional_info}`}
              </Typography>
            </Box>
          )}
          {!additional_info && question_type === 2 && (
            <Box display="flex">
              <Typography
                color="error"
                fontWeight={medium}
                component="span"
                display="flex"
                fontStyle="italic"
              >
                None
              </Typography>
            </Box>
          )}
        </Grid>
        {question_type === 1 && (
          <Grid
            item
            xs={12}
            sm={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Chip
              variant="outlined"
              color={response ? 'success' : 'error'}
              label={response ? 'Yes' : 'No'}
              style={{ borderRadius: '6px', height: '24px' }}
            />
          </Grid>
        )}
      </Grid>
      <Popover
        sx={{
          pointerEvents: 'none',
        }}
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'center',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
        slotProps={{
          paper: { style: { padding: 5 } },
        }}
      >
        <Typography sx={{ p: 1 }}>{`Prequalifying question answered ${
          preferred_answer === response ? 'correctly' : 'incorrectly'
        }`}</Typography>
      </Popover>
    </Box>
  );
};

export default ApplicationQuestionResponse;
